import { connect } from 'react-redux';
import ProgressBar from "./ProgressBar";
import {
    getLeftConsentsNumber, getNumberOfProcessedConsents,
    getNumberOfSkippedConsents
} from "../../../reducers/consent/consents";

const mapStateToProps = state => {
    return {
        left: getLeftConsentsNumber(state),
        skipped: getNumberOfSkippedConsents(state),
        validated: getNumberOfProcessedConsents(state)
    };
};

export default connect(mapStateToProps)(ProgressBar);



// WEBPACK FOOTER //
// ./src/components/commonComponents/progressBar/ApproveConsentProgressBar.container.js